import type { BrandInvitationVerificationData } from "../../../types/brand.types";

export const buildBrandInvitationSignupPath = ({
  BrandSubcategory,
  BrandSubcategorySlug,
  PifId,
}: BrandInvitationVerificationData) => {
  const categoryToken = BrandSubcategorySlug?.trim() || BrandSubcategory.trim();

  return `/auth/sporting-events/${encodeURIComponent(
    PifId
  )}/${encodeURIComponent(
    categoryToken
  )}`;
};
